<template>
  <v-expansion-panels v-model="panel" class="mt-4">
    <v-expansion-panel class="expansion-panel">
      <v-expansion-panel-header class="expansion-header">
        <v-img v-if="group.group_image_url && group.group_rules_exhibition === 'PUBLIC'" :src="group.group_image_url" class="expansion-header-img" contain />
        <div v-else-if="!group.group_image_url && group.group_rules_exhibition === 'PUBLIC'" class="expansion-header-img d-flex align-center justify-center">
          <mf-icon> image_not_supported </mf-icon>
        </div>

        <span v-if="groupHasRepeatedSku" class="expansion-header-title">
          <v-badge color="red" dark dot class="tabs-menu__error-badge">{{ group.name }}</v-badge>
        </span>
        <span v-else class="expansion-header-title">{{ group.name }}</span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <group-card-content
          :group="group"
          :headers="headers"
          :helpers="helpers"
          :offer-sales-type="offerSalesType"
          :repeated-skus="repeatedSkus"
          :validations="validations"
          :group-index="groupIndex"
          :search="search"
          :is-revision="isRevision"
          :disabled="disabled"
          :is-disabled-in-rules="isDisabledInRules"
          :is-industry-campaign="isIndustryCampaign"
          :tooltip-message="tooltipMessage"
          :campaign="campaign"
          @change-group-exhibition="$emit('change-group-exhibition', $event)"
          @remove-item="$emit('remove-item', $event)"
          @remove-group="$emit('remove-group')"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import GroupCardContent from './GroupCardContent.vue'
export default {
  name: 'GroupCard',
  components: {
    GroupCardContent,
  },
  props: {
    group: {
      type: Object,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => [],
    },
    helpers: {
      type: Object,
      default: () => {},
    },
    offerSalesType: {
      type: String,
      default: '',
    },
    repeatedSkus: {
      type: Array,
      default: () => [],
    },
    validations: {
      type: Object,
      default: () => {},
    },
    groupIndex: {
      type: Number,
      default: 0,
    },
    search: {
      type: String,
      default: '',
    },
    isRevision: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isDisabledInRules: {
      type: Function,
      default: () => false,
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    campaign: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    panel: false,
  }),
  computed: {
    productsInsideGroup() {
      return this.group.products
    },
    groupHasRepeatedSku() {
      if (this.repeatedSkus.length === 0) return false

      let groupRepeatedSkus = []
      this.productsInsideGroup.forEach((product) => {
        if (this.repeatedSkus.includes(product.sku)) groupRepeatedSkus.push(product.sku)
      })

      return groupRepeatedSkus.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.v-expansion-panel {
  padding: 12px 24px;
  &--active {
    padding: 12px 24px 24px;
  }
  &-content__wrap {
    padding: 0;
  }
  &-header {
    &--active {
      border-bottom: 1px solid $cinza-l80;
    }
    &__icon {
      padding-right: 16px;
    }
  }
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}
.expansion-header {
  display: flex;
  gap: 16px;
  padding: 0;

  &-img {
    max-width: 40px;
    height: 40px;
  }
  &-title {
    font-family: 'Lato';
    font-weight: 400;
    font-size: 18px;
    color: $cinza-d10;
  }
}
</style>
